/*
* @Author: gujianghua
* @Date:   2018-06-27 10:57:37
* @Last Modified by:   gujianghua
* @Last Modified time: 2018-09-07 11:28:48
*/
const user = {
	namespaced: true,

	state: {
		id: sessionStorage.getItem('id'),
		name: sessionStorage.getItem('name'),
		token: sessionStorage.getItem('token'),
		tokenName: sessionStorage.getItem('tokenName'),
		role: sessionStorage.getItem('role')
	},

	getters: {
		userId: state => {
			return state.id
		},
		userName: state => {
			return state.name
		},
		userToken: state => {
			return state.token
		},
		userTokenName: state => {
			return state.tokenName
		},
		userRole: state => {
			return state.role
		},
	},

	actions: {
		login ({ commit }, obj) {
			return new Promise((resolve, reject) => {
				commit('save',obj)
				resolve(obj)
			}).catch(error => {
				reject(error)
			})
		},
		loginOut ({ commit }) {
			return new Promise((resolve, reject) => {
				commit('remove')
				resolve()
			}).catch(error => {
				reject(error)
			})
		},
		setUserName ({ commit }, data) {
			return new Promise((resolve, reject) => {
				commit('setName', data)
				resolve()
			}).catch(error => {
				reject(error)
			})
		}
	},

	mutations: {
		save (state, obj) {
			for(let i in obj){
				sessionStorage.setItem(i, obj[i])
				state[i] = obj[i]
			}
		},
		remove (state) {
			sessionStorage.removeItem('token')
			sessionStorage.removeItem('tokenName')
			state = {}
		},
		setName (state, name) {
			console.log(name)
			state.name = name
		}
	}
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user/index.js